<div class="manage_quantity">

    <form [formGroup]="sessionSelectedForm" *ngIf="needSession()" >
      <select (change)="updateSessionSelected()" (click)="!offer.isSelected?  getMessageAddOfferToPaiment(true): null" formControlName="session">
        <option value="default" *ngIf="sessionsFiltered?.length">-- Selectionnez la date --</option>
        <option value="nosession" *ngIf="!sessionsFiltered?.length">-- Aucune date disponible --</option>
        <option *ngFor="let s of sessionsFiltered" [value]="s.sessionKey">{{s.dateLib}} -
          {{s.sessionStartDate | date: "shortDate":'UTC'}} - nbr. de places restantes: <strong>{{  s.quantity - s.bookedSessionTrainees }}</strong></option>
      </select>
    </form>

  <form [formGroup]="manageQuantityForm" class="action_quantity">
    <fa-icon [icon]="getFaIcon('faMinus')" (click)="offer?.isSelected || isCounter ? updateQuantity('minus') : getMessageAddOfferToPaiment()" [style.opacity]="fquantity.quantity.value" appChangeColorTheme attribute="bgc" > 1 ? 1 : .5">
    </fa-icon>
    <input [id]="'myInput_'+ type + '_' +index" type="number" min="1" formControlName="quantity"
      (focusout)="updateQuantity('input', $event)">
    <fa-icon [icon]="getFaIcon('faPlus')" (click)="offer?.isSelected || isCounter ? updateQuantity('plus'): getMessageAddOfferToPaiment()"
    [style.opacity]="fquantity.quantity.value  && (fquantity.quantity.value === limitQuantity) ? .5 : 1" appChangeColorTheme attribute="bgc"></fa-icon>
  </form>

  <div class="price" *ngIf="!offer.hasSession">
    <strong>{{priceWithoutSessions}}</strong>
  </div>

  <p class="message_book" *ngIf="offer?.sessionKey">
    <fa-icon [icon]="getFaIcon('faExclamationCircle')" appChangeColorTheme attribute="color"></fa-icon>
    Cette réservation ne sera effective que lors de la confirmation du panier.
  </p>

</div>
